import React from 'react';
import { NextArrow, PrevArrow } from './slider/arrows';

export const defaultSliderSettings = {
  infinite: false,
  swipeToSlide: false,
  swipe: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1680,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export const defaultAvailableDevices = {
  data: [
    {
      uid: 1,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T100',
      weight: '4.3',
      processor: 'Intel Core i3-1115G4',
      graphics_processor: 'Intel UHD',
      display: '15',
      memory: '8GB',
      hard_drive: '512GB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'RECOMMENDED',
        text: 'Recommended',
      },
    },
    {
      uid: 2,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T220',
      weight: '4',
      processor: 'Intel Core i5-1115G4',
      graphics_processor: 'Intel UHD',
      display: '14',
      memory: '16GB',
      hard_drive: '1TB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'RECOMMENDED',
        text: 'Recommended',
      },
    },
    {
      uid: 3,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T321',
      weight: '5',
      processor: 'Intel Core i7-1115G4',
      graphics_processor: 'nVIDIA RTX 3060 12GB',
      display: '17',
      memory: '32GB',
      hard_drive: '2TB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'NO_EXCEPTION_REQUIRED',
        text: 'No exception required',
      },
    },
    {
      uid: 4,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T430',
      weight: '4.2',
      processor: 'Intel Core i5-1115G4',
      graphics_processor: 'nVIDIA GTX 1660 6GB',
      display: '15',
      memory: '16GB',
      hard_drive: '256GB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'EXCEPTION_REQUIRED',
        text: 'Exception',
      },
    },
    {
      uid: 5,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T520',
      weight: '5',
      processor: 'Intel Core i7-1115G4',
      graphics_processor: 'nVIDIA GTX 1660 6GB',
      display: '14',
      memory: '8GB',
      hard_drive: '256GB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'NA',
        text: 'Not available',
      },
    },
    {
      uid: 6,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T621',
      weight: '3',
      processor: 'Intel Core i3-1115G4',
      graphics_processor: 'Intel UHD',
      display: '14',
      memory: '8GB',
      hard_drive: '256GB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'NA',
        text: 'Not available',
      },
    },
    {
      uid: 7,
      manufacturer: 'Lenovo',
      model: 'Intel@ core i-5',
      model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
      name: 'Lenovo ThinkPad T730',
      weight: '3',
      processor: 'Intel Core i5-1115G4',
      graphics_processor: 'nVIDIA GTX 1660 6GB',
      display: '14',
      memory: '8GB',
      hard_drive: '512GB SSD',
      language: 'English',
      type: 'Lightweight',
      exception_type: {
        value: 'EXCEPTION_REQUIRED',
        text: 'Exception',
      },
    },
  ],
  dataMeasureListDevice: [
    {
      uid: 1,
      weight: '4.3',
      size: '15',
    },
    {
      uid: 2,
      weight: '5',
      size: '16',
    },
  ],
};

export const defaultDevice = {
  manufacturer: 'Lenovo',
  model: 'Intel@ core i-5',
  model_picture: 'https://www.notebookcheck.net/uploads/tx_nbc2/teaser_39.jpg',
  name: 'Lenovo ThinkPad T430',
  model_memory: '4GB',
  model_processor: ' Intel Core i5 2.70GHz',
  model_weight: '2',
  model_display: '14',
  model_graphics_processor: 'AMD Radeon',
  model_hard_drive: '1TB',
  model_language: 'English (US)',
  type: 'Lightweight',
  serial_number: '',
  model_type: 'Executive Laptop',
};
